"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Flex, FlexColumn, Modal, ModalBody, ModalHeader, ModalHeaderTitle, RadioGroup, RadioGroupItem, TextBody, ToggleButtonGroup, ToggleButtonGroupItem } from "@opensea/ui-kit";
import { differenceInMilliseconds, isBefore, parseISO } from "date-fns";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { useShallow } from "zustand/react/shallow";
import { useDropStore } from "@/components/collection/drops/components/CollectionDropContext";
import { useFormatStageDate } from "@/components/collection/drops/use-format-stage-date";
import { AddtoCalendarOptions } from "./AddtoCalendarOptions";
import { EmailAddressOption } from "./EmailAddressOption";
import { SetDropReminderModalFragment } from "./SetDropReminderModal.fragment";
export function SetDropReminderModal(t0) {
  const $ = _c(46);
  const {
    drop: dropKey
  } = t0;
  const drop = readFragment(SetDropReminderModalFragment, dropKey);
  const [collectionSlug, isReminderModalOpen, setIsReminderModalOpen, activeStageIndex] = useDropStore(useShallow(_temp));
  const formatStageDate = useFormatStageDate();
  const activeStage = drop?.stages.find(stage => stage.stageIndex === activeStageIndex);
  const t = useTranslations("SetDropReminderModal");
  const stageDates = drop?.stages?.map(_temp2).filter(_temp3) ?? [];
  const firstStageDate = stageDates.length > 0 ? new Date(Math.min(...stageDates.map(_temp4))) : undefined;
  const now = new Date();
  const isBeforeFirstStage = firstStageDate !== undefined && isBefore(now, firstStageDate);
  const withinOneHourOfFirstStage = isBeforeFirstStage && firstStageDate !== undefined && differenceInMilliseconds(firstStageDate, now) <= 3600000;
  const [reminderType, setReminderType] = useState(withinOneHourOfFirstStage ? "calendar" : "email");
  let t1;
  if ($[0] !== reminderType || $[1] !== setReminderType || $[2] !== withinOneHourOfFirstStage) {
    t1 = () => {
      if (withinOneHourOfFirstStage && reminderType === "email") {
        setReminderType("calendar");
      }
    };
    $[0] = reminderType;
    $[1] = setReminderType;
    $[2] = withinOneHourOfFirstStage;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== reminderType || $[5] !== withinOneHourOfFirstStage) {
    t2 = [withinOneHourOfFirstStage, reminderType];
    $[4] = reminderType;
    $[5] = withinOneHourOfFirstStage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  const [selectedStageIndex, setSelectedStageIndex] = useState(String(activeStage?.stageIndex ?? 0));
  const selectedStage = drop?.stages.find(stage_0 => stage_0.stageIndex === Number(selectedStageIndex));
  if (!drop) {
    return null;
  }
  const T0 = Modal;
  let t3;
  if ($[7] !== t) {
    t3 = t("title");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <ModalHeader><ModalHeaderTitle>{t3}</ModalHeaderTitle></ModalHeader>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const T1 = ModalBody;
  const T2 = RadioGroup;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = val => {
      if (val != null) {
        setSelectedStageIndex(val);
      }
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = String(selectedStageIndex);
  let t7;
  if ($[12] !== formatStageDate) {
    t7 = stage_1 => <Flex className="items-center gap-3" key={stage_1.stageIndex}><RadioGroupItem value={String(stage_1.stageIndex)} /><FlexColumn><TextBody asChild={true} size="sm" weight="semibold"><label>{stage_1.label || "Public stage"}</label></TextBody><TextBody className="font-mono text-text-tertiary" size="xs">{formatStageDate(stage_1.startTime)}</TextBody></FlexColumn></Flex>;
    $[12] = formatStageDate;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = drop.stages.map(t7);
  let t9;
  if ($[14] !== T2 || $[15] !== t5 || $[16] !== t6 || $[17] !== t8) {
    t9 = <T2 onValueChange={t5} value={t6}>{t8}</T2>;
    $[14] = T2;
    $[15] = t5;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== reminderType || $[20] !== setReminderType || $[21] !== t || $[22] !== withinOneHourOfFirstStage) {
    t10 = withinOneHourOfFirstStage ? <TextBody className="mt-6 mb-2" size="md" weight="semibold">{t("chooseCalendar")}</TextBody> : <ToggleButtonGroup className="mt-6" onValueChange={type => {
      setReminderType(type);
    }} value={reminderType}><ToggleButtonGroupItem className="w-full justify-center" value="email">{t("emailReminders")}</ToggleButtonGroupItem><ToggleButtonGroupItem className="w-full justify-center" value="calendar">{t("addToCalendar")}</ToggleButtonGroupItem></ToggleButtonGroup>;
    $[19] = reminderType;
    $[20] = setReminderType;
    $[21] = t;
    $[22] = withinOneHourOfFirstStage;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== collectionSlug || $[25] !== drop || $[26] !== reminderType || $[27] !== selectedStage?.uuid || $[28] !== selectedStageIndex || $[29] !== withinOneHourOfFirstStage) {
    t11 = <FlexColumn className="mt-4 gap-4">{withinOneHourOfFirstStage || reminderType === "calendar" ? <AddtoCalendarOptions drop={drop} selectedStageIndex={selectedStageIndex} /> : <EmailAddressOption collectionSlug={collectionSlug} selectedStageUuid={selectedStage?.uuid} />}</FlexColumn>;
    $[24] = collectionSlug;
    $[25] = drop;
    $[26] = reminderType;
    $[27] = selectedStage?.uuid;
    $[28] = selectedStageIndex;
    $[29] = withinOneHourOfFirstStage;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== T1 || $[32] !== t10 || $[33] !== t11 || $[34] !== t9) {
    t12 = <T1>{t9}{t10}{t11}</T1>;
    $[31] = T1;
    $[32] = t10;
    $[33] = t11;
    $[34] = t9;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t12 || $[37] !== t4) {
    t13 = <>{t4}{t12}</>;
    $[36] = t12;
    $[37] = t4;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== setIsReminderModalOpen) {
    t14 = isOpen => setIsReminderModalOpen(isOpen);
    $[39] = setIsReminderModalOpen;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== T0 || $[42] !== isReminderModalOpen || $[43] !== t13 || $[44] !== t14) {
    t15 = <T0 content={t13} onOpenChange={t14} open={isReminderModalOpen} />;
    $[41] = T0;
    $[42] = isReminderModalOpen;
    $[43] = t13;
    $[44] = t14;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  return t15;
}
function _temp4(d_0) {
  return d_0.getTime();
}
function _temp3(d) {
  return Number.isFinite(d.getTime());
}
function _temp2(s) {
  return parseISO(s.startTime);
}
function _temp(state) {
  return [state.collectionSlug, state.isReminderModalOpen, state.setIsReminderModalOpen, state.activeStageIndex];
}